import React from 'react';
import { useSelector } from 'react-redux';
import AvatarSvg from './Avatar.svg';
import styles from './Avatar.module.css';
import { useNavigate, useLocation } from 'react-router-dom';

function Avatar() {
    const navigate = useNavigate();
    const location = useLocation();
    const user_name = useSelector((state) => state.user.username)

    const isActive = location.pathname === '/settings';

    const handleClick = () => {
      navigate('/settings');
    };

    return (
      <button className={`${styles.layout} ${isActive ? styles.active : ''}`} onClick={handleClick}>
        <img src={AvatarSvg} alt="Avatar" className={styles.icon} />
        <p className={styles.username}>{user_name}</p>
      </button>  
    );
}

export default Avatar;
